'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounceApi = exports.DEBOUNCED = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var DEBOUNCED = exports.DEBOUNCED = 'DEBOUNCED';

/**
 * Debounce calls to an API. When an call is in progress, calls are queued.  When the call completes,
 * the most recent call is invoked and all queued calls receive the result.
 *
 * If a call is debounced it will resolve with wrappedFunction.DEBOUNCED as a value
 *
 * @example
 *   const wrapped = debounceApi(myApi);
 *
 *   myApi().then(result => {
 *     if (result === myApi.DEBOUNCED) return; // This call was debounced
 *     doSomethingWith(result);
 *   });
 *
 * @param {Function} func api function to call.  This function must return a promise
 * @returns {Promise}
 */
var debounceApi = exports.debounceApi = function debounceApi(func) {
  var previousCall = _q2.default.Promise.resolve();
  var nextArgs = null;

  var callMostRecent = function callMostRecent() {
    var promise = func.apply(undefined, _toConsumableArray(nextArgs));
    nextArgs = null;
    return promise;
  };

  var callMostRecentAfterSuccess = function callMostRecentAfterSuccess() {
    if (!nextArgs) return DEBOUNCED;
    return callMostRecent();
  };

  var callMostRecentAfterFailure = function callMostRecentAfterFailure() {
    if (!nextArgs) return DEBOUNCED;
    return callMostRecent();
  };

  var wrapped = function wrapped() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    nextArgs = args;
    previousCall = previousCall.then(callMostRecentAfterSuccess, callMostRecentAfterFailure);
    return previousCall;
  };

  wrapped.DEBOUNCED = DEBOUNCED;

  return wrapped;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/utils/debounceApi.js
// module id = 793
// module chunks = 2 3